var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMountainsWithSun = function SvgMountainsWithSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 95,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mountains-with-sun_svg__a",
    width: 212,
    height: 95,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.898.575h210.196v94.376H.898z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mountains-with-sun_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.96,
    cy: 32.976,
    r: 19.785,
    fill: "#F6BC2D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M82.283 107.109c-3.571-.003-5.348-4.33-2.81-6.843l65.142-64.476a4 4 0 0 1 5.656.03l63.944 64.603c2.501 2.527.709 6.817-2.847 6.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M23.544 107.232c-3.571 0-5.352-4.325-2.816-6.84l49.794-49.371a4 4 0 0 1 5.656.023l48.964 49.382c2.504 2.525.715 6.817-2.841 6.817z"
  }))));
};
export { SvgMountainsWithSun as ReactComponent };
export default __webpack_public_path__ + "images/mountains-with-sun.svg";